
export const changesLog = {
  data () {
    return {
      versionLog: '0.0.9',
      changes: [
        {
          title: 'Изменения в работе заказов ETALON',
          lines: [
            'Добавлена настройка очереди отправителей палет',
            'Отображение отправителя в заказе',
            'Печать ТТН из заказа ETALON'
          ]
        }
      ]
    }
  },
  methods: {
    getLogHTML () {
      let html = ''
      this.changes.forEach(item => {
        html += '<h3 class="mt-2">' + item.title + '</h3>'
        html += '<ul>'
        item.lines.forEach(line => {
          html += '<li>' + line + '</li>'
        })
        html += '</ul>'
      })

      return html
    }
  }
}
